
export class BaoConstants {

    static readonly JWT_TOKEN = 'bao.co.tz.token';
    static readonly USER_MODEL = 'bao.co.tz.user';
    static readonly EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

    static readonly ROLE_DEALER = 'dealer';
    static readonly ROLE_MANAGER = 'manager';
    static readonly ROLE_ADMINISTRATOR = 'administrator';
}
